import type { QueueTrafficInfo } from "@/models";
import { getSelectedSessionId } from "@/sdk";
import { getSharedApiClient } from "@/shared-utils";

export const getAllQueueVolumes = async (): Promise<QueueTrafficInfo[]> => {
    const response = await getSharedApiClient().get(`api/traffic-control/v1/queues`, {
        headers: {
            "x-ewp-correlation-id": getSelectedSessionId(),
        },
    });

    return response.json<QueueTrafficInfo[]>();
};
